import { Flex } from '@mantine/core';
import type { DataAccessRequestMetrics } from '@repo/api-codegen';
import { memo, useCallback } from 'react';
import type { RequestMetricCardType } from '../../types';
import {
	AccessRemovedIcon,
	AlertIcon,
	NormalIcon,
	OpenIncidentsIcon,
} from '../icons';
import { MetricsOverviewCard } from '../MetricsOverviewCard';

export interface MetricsRequestCardsProps {
	requestMetrics: DataAccessRequestMetrics;
	onMetricCardClick?: (metricType: RequestMetricCardType) => void;
}

export const MetricsRequestCards = memo(
	({ requestMetrics, onMetricCardClick }: MetricsRequestCardsProps) => (
		<Flex py="lg" w="100%" justify="space-between" align="center" gap="md">
			<MetricsOverviewCard
				title="Open"
				value={requestMetrics?.status_counts?.open ?? 0}
				icon={OpenIncidentsIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Open'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="Active"
				value={requestMetrics?.status_counts?.granted ?? 0}
				icon={NormalIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Active'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="Denied"
				value={requestMetrics?.status_counts?.rejected ?? 0}
				icon={AlertIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Denied'),
					[onMetricCardClick]
				)}
			/>
			<MetricsOverviewCard
				title="Closed"
				value={
					(requestMetrics?.status_counts?.expired ?? 0) +
					(requestMetrics?.status_counts?.cancelled ?? 0)
				}
				icon={AccessRemovedIcon}
				onClick={useCallback(
					() => onMetricCardClick?.('Closed'),
					[onMetricCardClick]
				)}
			/>
		</Flex>
	)
);

MetricsRequestCards.displayName = 'MetricsRequestCards';
